import axios from "../api";

// LIST COUNTRY DOCUMENTS
export const listCountryDocumentsAction = (
  page,
  limit,
  search = "",
  country_id = "",
  document_type_id = "",
  is_supported = ""
) => {
  let apiUrl = `/api/kyc/country-documents?page=${page}&limit=${limit}`;

  if (search) {
    apiUrl += `&search=${search}`;
  }

  if (country_id) {
    apiUrl += `&country_id=${country_id}`;
  }

  if (document_type_id) {
    apiUrl += `&document_type_id=${document_type_id}`;
  }

  if (is_supported !== "") {
    apiUrl += `&is_supported=${is_supported}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};

// GET COUNTRY DOCUMENT BY ID
export const getCountryDocumentByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/kyc/country-documents/${id}`)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// CREATE COUNTRY DOCUMENT
export const createCountryDocumentAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/kyc/country-documents/`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// UPDATE COUNTRY DOCUMENT
export const updateCountryDocumentAction = async (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/kyc/country-documents/${id}`, data)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// DELETE COUNTRY DOCUMENT (soft delete)
export const deleteCountryDocumentAction = async (id, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/kyc/country-documents/${id}`, {
        data: payload,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// UPDATE COUNTRY DOCUMENT STATUS
export const updateCountryDocumentStatusAction = async (id, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/kyc/country-documents/${id}/status`, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}; 